import {useCompanyTariffGuard} from '../../../../modules/company-tariff';
import {FC, useState} from 'react';

import {IDeviceTypesDict} from '../../../../shared/types/deviceTypesDict.types';
import {Button, List, Stack, Typography} from '@mui/material';
import {DeviceSubtypeListItem} from './DeviceSubtypeListItem';
import AddIcon from '@mui/icons-material/Add';

import {green} from '@mui/material/colors';
import {ModalNewOrUpdateSubtype} from './ModalNewOrUpdateSubtype';

interface IDeviceSubtypeList {
  subtypes: IDeviceTypesDict[];
  deviceType: IDeviceTypesDict;
}

export const DeviceSubtypeList: FC<IDeviceSubtypeList> = ({subtypes, deviceType}) => {
  const {checkTariff, tariffLoading} = useCompanyTariffGuard();
  const [open, setOpen] = useState(false);

  const toggleModalToCreate = () => {
    if (!open && !checkTariff()) return;
    setOpen(!open);
  };

  return (
    <Stack direction="column" spacing={3} sx={{mt: 3}}>
      <Stack direction="row" sx={{alignItems: 'center'}} spacing={2}>
        <Typography>Подтипы</Typography>
        <Button
          onClick={toggleModalToCreate}
          disabled={tariffLoading}
          variant="contained"
          size="small"
          startIcon={<AddIcon />}
          sx={{
            ml: 3,
            height: '30px',
            fontSize: '0.87rem',
            whiteSpace: 'nowrap',
            letterSpacing: '0',
            textTransform: 'none',
            backgroundColor: green[500],
            '&:hover': {
              backgroundColor: green[600],
            },
          }}
        >
          Добавить
        </Button>
      </Stack>
      <List>
        {subtypes.map((i) => (
          <DeviceSubtypeListItem key={i.code + i.name} subtype={i} />
        ))}
      </List>
      {open && (
        <ModalNewOrUpdateSubtype open={open} variant="POST" deviceType={deviceType} handleClose={toggleModalToCreate} />
      )}
    </Stack>
  );
};
